import { render, staticRenderFns } from "./Voicemails.vue?vue&type=template&id=07cca6cc&"
import script from "./Voicemails.vue?vue&type=script&lang=js&"
export * from "./Voicemails.vue?vue&type=script&lang=js&"
import style0 from "./Voicemails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports